// PTQL tokenizer for CodeMirror 6 (via StreamLanguage adapter)
// This is intentionally just a tokenizer, not a parser.
// The authoritative grammar lives in the EBNF consumed by Instaparse

// NOTE: this is mainly for syntax highlighting

import { StreamLanguage } from "goog:module$node_modules$$codemirror$language$dist$index_cjs";

const KEYWORDS = new Set([
    "AND", "OR", "NOT", "IS", "EMPTY", "IN", "LAST", "VIEW", "COUNT",
    "LINKED", "TO", "WHERE", "STARTS", "WITH", "CONTAINS", "CURRENT_USER", "GROUP", "TODAY"
]);

export const ptqlLanguage = StreamLanguage.define({
    token(stream, _state) {
        // whitespace
        if (stream.eatSpace()) return null;

        // double-quoted string
        if (stream.match(/"(?:[^"\\]|\\.)*"/)) return "string";
        // single-quoted string
        if (stream.match(/'(?:[^'\\]|\\.)*'/)) return "variableName";
        // unterminated string (for mid-typing)
        if (stream.match(/"[^"]*$/)) return "string";
        if (stream.match(/'[^']*$/)) return "variableName";

        // multi-char operators first
        if (stream.match("!=") || stream.match(">=") || stream.match("<=")) return "compareOperator";
        // single-char operators
        if (stream.match("=") || stream.match(">") || stream.match("<")) return "compareOperator";

        // parens
        if (stream.eat("(") || stream.eat(")")) return "paren";

        // numbers
        if (stream.match(/\d+(\.\d+)?/)) return "number";

        // words - keyword or field name
        if (stream.match(/[a-zA-Z_]\w*/)) {
            if (KEYWORDS.has(stream.current())) return "keyword";
            return "variableName";
        }

        // unknown char - advance
        stream.next();
        return null;
    }
});
